export const FBA_TRANSFER_STATUS_LABELS = {
  DRAFT: 'Draft',
  SHIPHERO_REMOVED: 'ShipHero Removed',
  AWAITING_AMAZON_SHIPMENT: 'Awaiting Amazon Shipment',
  AMAZON_INBOUND: 'Amazon Inbound',
  PARTIALLY_RECEIVED: 'Partially Received',
  RECEIVED: 'Received',
  EXCEPTION: 'Exception',
  CANCELLED: 'Cancelled',
  CANCELLATION_EXCEPTION: 'Cancellation Exception',
  CANCELLED_REVERSED: 'Cancelled — Reversed',
  CANCELLED_AFTER_DISPATCH: 'Cancelled After Dispatch / Needs Recovery',
  IMPORTED: 'Imported (historical)',
};

const palette = {
  DRAFT: 'bg-gray-100 text-gray-600',
  SHIPHERO_REMOVED: 'bg-indigo-100 text-indigo-700',
  AWAITING_AMAZON_SHIPMENT: 'bg-amber-100 text-amber-800',
  AMAZON_INBOUND: 'bg-blue-100 text-blue-700',
  PARTIALLY_RECEIVED: 'bg-sky-100 text-sky-700',
  RECEIVED: 'bg-green-100 text-green-700',
  EXCEPTION: 'bg-red-100 text-red-700',
  CANCELLED: 'bg-gray-100 text-gray-500 line-through',
  CANCELLATION_EXCEPTION: 'bg-red-100 text-red-700',
  CANCELLED_REVERSED: 'bg-gray-100 text-gray-600',
  CANCELLED_AFTER_DISPATCH: 'bg-orange-100 text-orange-800',
  IMPORTED: 'bg-slate-100 text-slate-700',
};

export default function FbaTransferStatusChip({ status, className = '' }) {
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-sm font-medium leading-5 ${palette[status] || palette.DRAFT} ${className}`}>
      {FBA_TRANSFER_STATUS_LABELS[status] || status}
    </span>
  );
}
